import { RootState } from "../types";
import {
  CHANGE_LANGUAGE_SUCCESS,
  GET_LANGUAGE_SUCCESS,
} from "../localization/actionTypes";
import { relocalizeAdminTableHeaders } from "../tableData/actionCreators";

function subsequentDispatchMiddleware(store: RootState) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (next: any) => async (action: any) => {
    if (
      action.type === CHANGE_LANGUAGE_SUCCESS ||
      action.type === GET_LANGUAGE_SUCCESS
    ) {
      const res = next(action);
      store.dispatch(relocalizeAdminTableHeaders());
      return res;
    }

    return next(action);
  };
}

export default subsequentDispatchMiddleware;
